import { render } from "./WalletButton.vue?vue&type=template&id=0f857248&scoped=true"
import script from "./WalletButton.vue?vue&type=script&lang=js"
export * from "./WalletButton.vue?vue&type=script&lang=js"

import "./WalletButton.vue?vue&type=style&index=0&id=0f857248&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f857248"]])

export default __exports__